import { formatNumber } from './format-number.util';

export const formatMoney = (inputNumber: string | number, decimals: number = 2, decimalIndicator: string = '.', thousandsIndicator?: string) => {
    return formatNumber(inputNumber, decimals, decimalIndicator, thousandsIndicator);
};
